import React, { useState, useEffect, useRef } from 'react'
import './styles.scss'
import arrow from '../../assets/shop/ExpandArrowAddress.png'
import arrowDisable from '../../assets/shop/ExpandArrowAddressDisable.png'

const SelectAddress = ({ tagname, options, onChange, value }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState(null)
  const selectedOptionRef = useRef(null)
  const closeRef = useRef(null)
  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  const handleOptionClick = (option) => {
    setSelectedOption(option)
    onChange(option.value)
    setIsOpen(false)
  }

  // Update selectedState
  useEffect(() => {
    const initialSelectedOption = options.find((option) => option.value === value)
    setSelectedOption(initialSelectedOption)

    // Scroll to the selected option when the dropdown opens
    if (isOpen && selectedOptionRef.current) {
      selectedOptionRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'start'
      })
    }
  }, [value, options, isOpen])

  const handleClickOutside = (event) => {
    if (closeRef.current && !closeRef.current.contains(event.target)) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [])

  return (
    <div className="frame-select-checkout">
      <div className="custom-select">
        <div className="select-container">
          <div className="selected-option">
            <p className={`${!options[0] ? 'disable-tagname' : ''}`}>
              {selectedOption ? selectedOption.label : tagname}
            </p>
          </div>
          <div className="arrow-icon">
            {options[0] ? (
              <img src={arrow} alt="" onClick={toggleDropdown} />
            ) : (
              <img src={arrowDisable} alt="" />
            )}
          </div>
        </div>
        {isOpen && (
          <div className="frame-options" ref={closeRef}>
            <div className="title-select">
              <p>{tagname}</p>
            </div>
            <ul>
              {options.map((option) => (
                <li
                  key={option.value}
                  onClick={() => handleOptionClick(option)}
                  ref={(ref) => {
                    if (value === option.value) {
                      selectedOptionRef.current = ref
                    }
                  }}
                  className={`${value === option.value ? 'checked-address' : ''}`}
                >
                  {option.label}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

export default SelectAddress
